// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__0oXc0","wrapper":"style__wrapper__2-zVv"};